<template>
  <paper
    class="card-info"
    :tabbed="!showTitle"
  >
    <template
      v-if="showTitle"
      v-slot:title
    >
      <p class="mb-0">
        Memory
      </p>
    </template>
    <div class="row">
      <input-field
        label="Capacity"
        label-position="top"
        class="px-1"
      >
        {{ formatBytes(capacity) }}
      </input-field>
    </div>
  </paper>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'

export default {
  name: 'MemoryInfo',
  components: { Paper },
  props: {
    capacity: {
      type: Number,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
